import { render, staticRenderFns } from "./form-step.vue?vue&type=template&id=25a9a5d2&scoped=true"
import script from "./form-step.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-step.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./form-step.vue?vue&type=style&index=0&id=25a9a5d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a9a5d2",
  null
  
)

export default component.exports